<template>
	<div class="meet__modal">
			<div class="meet__bg" @click="$emit('resetCity')"></div>
			<div class="meet__modal-content">
				<div class="meet__close" @click="$emit('resetCity')">X</div>
				<div class="meet__modal-image">
					<slot name="image"></slot>
					<p><slot name="title"></slot></p>
				</div>
				<div class="meet__modal-text">
					<slot name="text"></slot>
				</div>
				<div class="meet__modal-audio">
					<div class="audio">
						<slot name="audio"></slot>
					</div>
				</div>
				<div class="meet__modal-video" @click="openVideo" v-if="!showVideo">
					<slot name="video"></slot>
					<i></i>
				</div>
				<div class="meet__modal-player" v-else>
						<vimeo-player ref="player" :video-id="video" :autoplay="true" />
				</div>
			</div>
		</div>
</template>

<script>
	import vueVimeoPlayer from 'vue-vimeo-player'
	import Vue from 'vue'
	Vue.use(vueVimeoPlayer)
	export default {
		data() {
			return {
				showVideo: false,
			}
		},
		props: {
			video: String,
			event: String,
			event_m: String,
		},
		methods: {
			openVideo() {
				this.showVideo = true;
				if (this.event && this.event_m) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': this.event});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': this.event_m});
					}
				}
			}
		}
	}
</script>